import React, { useState } from 'react';
import { Save, Brain } from 'lucide-react';
import Modal from '../design-system/Modal';
import Button from '../design-system/Button';
import { Textarea } from '../design-system';

const MENTAL_STATES = ['Focus', 'Neutre', 'Tilté', 'Fatigué'];
const MOOD_COLORS = {
  Focus: 'text-cyan-400 border-cyan-400',
  Neutre: 'text-zinc-400 border-zinc-400',
  Tilté: 'text-rose-400 border-rose-400',
  Fatigué: 'text-amber-400 border-amber-400'
};

export default function SessionEditModal({ session, onClose, onSave }) {
  const [mentalGlobal, setMentalGlobal] = useState(session.mental_global || 'Neutre');
  const [insights, setInsights] = useState(session.insights || '');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(session.id, { mental_global: mentalGlobal, insights: insights.trim() || null });
      onClose();
    } catch (e) {
      alert('Erreur : ' + e.message);
      setSaving(false);
    }
  };

  const isPositive = session.wins > session.losses;

  return (
    <Modal
      open
      onClose={onClose}
      title={<span className="flex items-center gap-2">
        <span className={isPositive ? 'text-cyan-400' : 'text-fuchsia-400'}>{session.wins}-{session.losses}</span>
        <span className="text-zinc-600 text-sm">·</span>
        <span className="text-zinc-400 text-sm font-mono">{new Date(session.closed_at).toLocaleString('fr-FR', { dateStyle: 'medium', timeStyle: 'short' })}</span>
      </span>}
      subtitle={<span className="flex items-center gap-1"><Brain size={10} /> Édition de session</span>}
      size="lg"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={saving}>ANNULER</Button>
          <Button variant="primary" onClick={handleSave} disabled={saving} loading={saving}>
            <Save size={14} /> {saving ? 'SAUVEGARDE...' : 'ENREGISTRER'}
          </Button>
        </>
      }
    >
      <div className="space-y-5">
        <div>
          <div className="text-[10px] tracking-[0.25em] text-zinc-500 uppercase mb-2 font-semibold">Mental global de la session</div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            {MENTAL_STATES.map(state => (
              <button key={state} onClick={() => setMentalGlobal(state)}
                className={`p-3 border-2 font-bold tracking-wider text-sm transition ${mentalGlobal === state ? `${MOOD_COLORS[state]} bg-opacity-10` : 'border-zinc-800 text-zinc-500 hover:border-zinc-700'}`}
                style={mentalGlobal === state ? { backgroundColor: 'rgba(255,255,255,0.03)' } : {}}>
                {state}
              </button>
            ))}
          </div>
        </div>

        <Textarea
          label="Insights / Notes"
          value={insights}
          onChange={(e) => setInsights(e.target.value)}
          placeholder="Qu'est-ce que tu retiens de cette session ? Patterns observés, erreurs, choses à corriger..."
          rows={5}
          autoFocus
        />

        <div className="border border-zinc-800 bg-zinc-900/50 p-3 text-xs font-mono">
          <div className="text-[10px] tracking-[0.3em] text-zinc-500 uppercase mb-2">Détails de la session</div>
          <div className="space-y-1 text-zinc-400">
            <div>Games : <span className="text-white">{session.games_count}</span></div>
            <div>Résultat : <span className={isPositive ? 'text-cyan-400' : 'text-fuchsia-400'}>{session.wins}W / {session.losses}L</span></div>
            <div>Date : <span className="text-white">{new Date(session.closed_at).toLocaleString('fr-FR')}</span></div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
